import TradeStatsHeader from './TradeStatsHeader';
export { TradeStatsHeader };
export default TradeStatsHeader;
